import React, { useEffect, useRef, useState } from 'react';
import './custom-carousal.scss';
import { View } from '../../common';
import { ReactComponent as ArrowLeft } from '@zonofi/svg-icons/arrow_left.svg';
import { ReactComponent as ArrowRight } from '@zonofi/svg-icons/arrow_right.svg';
import { choosePlanCarousalImages } from '../../constants';

interface CustomCarousalProps {
  carousalItems?: any[];
}

export const CustomCarousal: React.FC<CustomCarousalProps> = ({
  carousalItems = choosePlanCarousalImages,
}) => {
  const [currentImgInCarousal, setCurrentImgInCarousal] = useState<number>(0);

  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleCaraousalImagesAutoIncrement = () => {
      setCurrentImgInCarousal((prev) => (prev + 1) % carousalItems.length);
    };

    const interval = setInterval(handleCaraousalImagesAutoIncrement, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    console.log('currentImgInCarousal : ', currentImgInCarousal);
  }, [currentImgInCarousal]);

  return (
    <View className="custom-carousal" ref={containerRef}>
      <View
        className="custom-carousal-items"
        style={{
          left: `-${currentImgInCarousal * 100}%`,
        }}
      >
        {carousalItems.map((item, index) => (
          <View
            className="custom-carousal-items-item"
            key={index}
            style={{
              width: containerRef?.current?.clientWidth || '100%',
            }}
          >
            <img
              className="custom-carousal-items-item-img"
              src={item}
              key={index}
              width={containerRef?.current?.clientWidth || 345}
              alt={`carousal item img ${index}`}
            />
          </View>
        ))}
      </View>
      <View className="custom-carousal-controlls">
        <View
          className="custom-carousal-controlls-arrows"
          onPress={() => {
            setCurrentImgInCarousal((prev) =>
              prev === 0 ? carousalItems.length - 1 : prev - 1
            );
          }}
        >
          <ArrowLeft
            width={16}
            height={16}
            color={`${currentImgInCarousal < 1 ? '#8C8C8C' : '#000000'}`}
          />
        </View>
        <View className="custom-carousal-controlls-state">
          <View className="custom-carousal-controlls-state-dots">
            {carousalItems.map((item, index) => (
              <View
                key={index}
                className={`custom-carousal-controlls-state-dots-dot ${
                  currentImgInCarousal === index ? 'active' : ''
                }`}
                style={{
                  width: `calc(100% / ${carousalItems.length})`,
                }}
                onPress={() => setCurrentImgInCarousal(index)}
              />
            ))}
          </View>
        </View>
        <View
          className="custom-carousal-controlls-arrows"
          onPress={() => {
            setCurrentImgInCarousal((prev) =>
              prev === carousalItems.length - 1 ? 0 : prev + 1
            );
          }}
        >
          <ArrowRight
            width={16}
            height={16}
            color={`${currentImgInCarousal > carousalItems.length - 2 ? '#8C8C8C' : '#000000'}`}
          />
        </View>
      </View>
    </View>
  );
};
